import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Case_Arrow } from "../../../../app-constants";
import { Link } from "gatsby";
import Logo9 from "../../../images/location_new/caseimg/ios-logo-1.webp";
import Img9 from "../../../images/location_new/caseimg/ios-case-1.webp";
import Logo2 from "../../../images/location_new/caseimg/ios-logo-2.webp";
import Img2 from "../../../images/location_new/caseimg/ios-case-2.webp";
import Logo3 from "../../../images/location_new/caseimg/ios-logo-3.webp";
import Img3 from "../../../images/location_new/caseimg/ios-case-3.webp";
import Logo6 from "../../../images/location_new/caseimg/ios-logo-4.webp";
import Img6 from "../../../images/location_new/caseimg/ios-case-4.webp";

const CaseStudy = [
  {
    logo: Logo9,
    title: "The Idea Behind Teemates",
    description:
      "TeeMates is an exemplary app for golfers. Connect with this app to share and communicate with global buddies. Enhance your golfing experience.",
    link: "teemates",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img9,
    BgColor: "#F7F7F7",
    TextColor: "#99B64B",
  },
  {
    logo: Logo2,
    title: "The Idea Behind MoCuts",
    description:
      "MoCuts is your go-to app for finding professional barbers and beauticians. Get hassle-free online reservations and grow your grooming experience with industry experts.",
    link: "mocuts",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img2,
    BgColor: "#fff3f2",
    TextColor: "#78332a",
  },
  {
    logo: Logo3,
    title: "The Idea Behind Pure Plank",
    description:
      "Pure Plank is a hub for fitness and workout enthusiasts aiming to look after their workout routine and health in the comfort of their homes to maximize their results.",
    link: "pure-plank",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img3,
    BgColor: "#19181e66",
    TextColor: "#97f084",
  },
  {
    logo: Logo6,
    title: "The Idea Behind Onsite Social",
    description:
      "OnSite Social, a TekRevol creation, bridges the physical and digital realms, forging meaningful real-time connections among users.",
    link: "onsite",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img6,
    BgColor: "#f3faff",
    TextColor: "#54a4c9",
  },
];

function Stories(props) {
  return (
    <div className="section_stories p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              TekRevol’s Success Stories as a Leading iPhone App Development
              Company in London
            </h2>

            <p className="z_idx">
              Our success stories speak volumes about the outcomes we deliver
              for our iOS mobile app development clients. Discover the impact of
              choosing one of the top iOS app development companies in London:
            </p>
          </Col>
          {CaseStudy.map((item, index) => (
            <Col
              xs={12}
              md={12}
              lg={6}
              xl={6}
              xxl={6}
              className="my-auto"
              key={index}
            >
              <div
                className="stories_item"
                style={{ backgroundColor: item.BgColor }}
              >
                <div className="item_logo">
                  <LazyLoadImage
                    src={item.logo}
                    effect="blur"
                    alt={item.title}
                    className="img-fluid"
                  />
                  <ul
                    style={{
                      color: item.TextColor,
                      borderColor: item.TextColor,
                    }}
                  >
                    <li>{item.technology.iOS}</li>
                    <li>{item.technology.Android}</li>
                  </ul>
                </div>
                <div className="item_tech">
                  <div className="tech_content">
                    <h4 style={{ color: item.TextColor }}>{item.title}</h4>
                    <p>{item.description}</p>

                    <Link
                      to={
                        item.link
                          ? `/case-studies/${item.link}`
                          : "https://www.tekrevol.com/projects"
                      }
                      className="case_btn"
                      aria-label="TekRevol Contact"
                      style={{ backgroundColor: item.TextColor }}
                    >
                      View Case Study {Case_Arrow}
                    </Link>
                  </div>
                  <div className="tech_img">
                    <LazyLoadImage
                      src={item.Img}
                      effect="blur"
                      alt={item.title}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default Stories;
